import React from 'react';
import './InlineSaveBanner.css';

interface InlineSaveBannerProps {
  triggerCoinName?: string;
  onOpenModal: () => void;
  onClose: () => void;
}

export const InlineSaveBanner: React.FC<InlineSaveBannerProps> = ({
  triggerCoinName,
  onOpenModal,
  onClose
}) => {
  return (
    <div className="inline-save-banner">
      <div className="inline-banner-header">
        <div className="inline-banner-text">
          🎉 <strong>Rare Discovery!</strong> {triggerCoinName ? `(${triggerCoinName})` : ''} — Link Google or Discord to save your collection permanently.
        </div>
        <button
          className="inline-banner-close"
          onClick={onClose}
          title="Dismiss banner"
        >
          &times;
        </button>
      </div>

      <div className="inline-banner-action-row">
        <button className="inline-save-btn" onClick={onOpenModal}>
          🔒 Save Collection (Google / Discord)
        </button>
      </div>
    </div>
  );
};
